import { CardLabels } from 'palette/ProductCard/types/productData';

export const ORIENTATIONS = ['vertical', 'horizontal'] as const;
export type OrientationType = typeof ORIENTATIONS[number];
export const SIZES = ['large', 'small'] as const;
export type SizeType = typeof SIZES[number];
export type TActionButtonsPosition = 'float' | 'image' | 'description';

enum CardTypes {
    listingPage = 'listingPage',
    beautyBestSeller = 'beautyBestSeller',
    frontPageCarousel = 'frontPageCarousel',
    recentlyViewedPDP = 'recentlyViewedPDP',
    RFListingLeftSticky = 'RFListingLeftSticky',
    RFListingRightSticky = 'RFListingRightSticky',
    horizontalStickyRF = 'horizontalStickyRF',
    upsell = 'upsell',
    sizePicker = 'sizePicker',
    outOfStockItem = 'outOfStockItem',
    combineWith = 'combineWith',
    relatedItems = 'relatedItems',
    RecentsFavoritesSlideInPanel = 'RecentsFavoritesSlideInPanel',
    shareCollection = 'shareCollection',
    addCollectionToCart = 'addCollectionToCart',
    alternativeItems = 'alternativeItems',
}
export interface ICardType {
    orientation: OrientationType;
    size: SizeType;
    actionButtonsPosition?: TActionButtonsPosition;
    hasHoverEffect?: boolean;
    floatPriceToRight?: boolean;
    hasSingleItemData?: boolean;
    hasToShowSingleItemDataAsList?: boolean;
}

type CardTypesInterface = { [key in CardTypes]?: ICardType };

export const CARD_TYPES_ATTRIBUTES : CardTypesInterface = {
    listingPage: {
        orientation: 'vertical',
        size: 'large',
        hasHoverEffect: true,
    },
    beautyBestSeller: {
        orientation: 'vertical',
        size: 'large',
    },
    frontPageCarousel: {
        orientation: 'vertical',
        size: 'large',
    },
    recentlyViewedPDP: {
        orientation: 'vertical',
        size: 'small',
    },
    RFListingLeftSticky: {
        orientation: 'vertical',
        size: 'small',
    },
    horizontalStickyRF: {
        orientation: 'vertical',
        size: 'small',
    },
    upsell: {
        orientation: 'horizontal',
        size: 'small',
    },
    sizePicker: {
        orientation: 'horizontal',
        size: 'small',
        floatPriceToRight: true,
    },
    outOfStockItem: {
        orientation: 'horizontal',
        size: 'small',
    },
    combineWith: {
        orientation: 'horizontal',
        size: 'small',
    },
    relatedItems: {
        orientation: 'vertical',
        size: 'large',
    },
    RecentsFavoritesSlideInPanel: {
        orientation: 'vertical',
        size: 'large',
    },
    shareCollection: {
        orientation: 'vertical',
        size: 'large',
    },
    addCollectionToCart: {
        orientation: 'horizontal',
        size: 'small',
        floatPriceToRight: true,
    },
    alternativeItems: {
        orientation: 'vertical',
        size: 'large',
    },
} as const;

export const CARD_LABELS: CardLabels = {
    comingSoon: 'Coming soon',
    quantity: 'Quantity',
    outOfStock: 'Out of stock',
};

export const CARD_THEMES = {
    default: 'default',
    dark: 'dark',
} as const;
